import React from "react";
import { GAME_OPERATIONS } from "../autoMatchingHelpers/GameOperations";
import { useMutation } from "../../../../hooks/useMutation";
import { getDefaultsForGame } from "../autoMatchingHelpers/gameDefaults";
import { useUser } from "../../../UserProvider";
import { useClient } from "urql";
import { useHistory } from "react-router-dom";

export const useGameTable = (sectionId: string) => {
  const client = useClient();
  const { user } = useUser();
  const { push } = useHistory();
  const gameKey = sectionId.split(":")[1];
  const operation = GAME_OPERATIONS[gameKey as keyof typeof GAME_OPERATIONS];

  const [, executeMutation] = useMutation(operation?.mutation ?? null);

  const createTableFlow = async () => {
    const { data, error } = await client
      .query(operation.query, { sectionId })
      .toPromise();

    if (error) throw error;

    const configKey = Object.keys(data)[0];
    const configData = data[configKey];
    const defaults = getDefaultsForGame(sectionId, configData, user.name);

    const result = await executeMutation({ input: { sectionId, ...defaults } });

    if (result.data) {
      const mutationName = Object.keys(result.data)[0];
      const tableData = result.data[mutationName];

      if (tableData?.id) {
        push(`/area/${sectionId}/${tableData.id}`);
      } else {
        console.error("Error");
      }
    }

    return result;
  };

  return { createTableFlow };
};
